<template>
  <div id="right-col" class="pure-u-1-5 aux-col" v-bind:class="{ viewingUser: isUserView, viewingTags: isTagsView, viewingMessages: isMessagesView, forceShow: forceRHShow }">
    <div id="user-lookup">
      <div class="users-heading-wrap">
        <h5 class="aux-heading">Find readers</h5>
        <div class="button-messages" v-on:click.stop.prevent="goToMessages()">
          <span id="unread-message-count"></span>
          <i class="fal fa-paper-plane"></i><span>Message</span>
        </div>
      </div>
      <div class="user-search">
        <input id="search-users" type="text" v-model="userSearchQuery" v-on:keyup.enter="searchUsers" placeholder="Search" />
        <div v-on:click="searchUsers" class="search-trigger"><i class="fal fa-search"></i></div>
      </div>
      <ul id="users-list">
        <li v-for="user in userSearchResults">
          <router-link class="button is-primary" v-on:click.native="viewUserProfile(user.key, user.username)" v-bind:to="{ name: 'user', params: { username: user.username }}">{{user.username}}</router-link>
        </li>
      </ul>
    </div>
    <div id="user-quick-profile">
      <div class="users-heading-wrap">
        <h5 class="aux-heading">{{currentUserUsername}}'s profile</h5>
        <div class="button-back" v-on:click.stop.prevent="backToUserSearch()">
          <i class="fal fa-long-arrow-left"></i>
        </div>
      </div>
      <a class="pure-button message-user-button" href="#" v-on:click.stop.prevent="messageUser()">Message @{{currentUserUsername}}</a>
      <ul class="tabs-nav">
        <li class="current" data-tab="grapes" v-on:click.stop.prevent="changeProfileTab('grapes')">{{grapes.length}} Grapes</li>
        <li data-tab="grapevines" v-on:click.stop.prevent="changeProfileTab('grapevines')">{{grapevines.length}} Grapevines</li>
      </ul>
      <ul id="users-grapes-list" class="visible grapes-list">
        <li v-for="grape in grapes" class="grape-list-grape" :data-id="grape.id">
          <router-link class="list-link" v-bind:to="{ name: viewGrapeLink, params: { grapeID: grape.id } }">
            <div class="grape-img-link"><img class="grape-img" :src="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage" /></div>
            <span class="grape-title">{{ grape.grapeTitle }}</span>
            <span class="grape-author">{{ grape.sourceAuthor }}</span>
          </router-link>
        </li>
      </ul>
      <ul id="users-grapevines-list" class="grapevines-list hidden">
        <li v-for="grapevine in grapevines" :data-id="grapevine.id" :data-name="grapevine.name" :data-read-only="grapevine.isReadOnly" :data-created="grapevine.created">
          <router-link class="list-link" v-on:click.native="viewGrapevine()" v-bind:to="{ name: grapevineViewLink, params: { id: grapevine.id, name: encodeURIComponent(grapevine.name) } }"><img class="grape-img" :src="grapevine.grapeImage" v-if="grapevine.grapeImage" /><span class="grapevine-name">{{ grapevine.name }}</span><span class="grapes-count">{{grapevine.count}}</span></router-link>
          <div class="hover-line"></div>
        </li>
      </li>

      </ul>
    </div>
  	<div id="grapevines-list-wrap" v-if="selectedGrapeID">
      <div class="users-heading-wrap">
        <h5 class="aux-heading">Notes</h5>
        <div class="button-back" v-on:click.stop.prevent="backToUserSearch()">
          <i class="fal fa-long-arrow-left"></i>
        </div>
      </div>
			<ul id="grape-aux-nav">
        <li data-tab="perfect">Perfect This Grape</li>
        <li data-tab="what-about" class="active">What Is This About?</li>
        <li data-tab="add-comment">Add A Comment</li>
      </ul>
      <!-- <div id="top-tag-wrap">
        <h5>Top Tag</h5>
        <span>{{topTag}}</span>
        </ul>
      </div>
      <div class="input-field add-tag-form" v-if="isLoggedIn">
        <label for="add_grape_tag">Add Your Own</label>
        <input name="add_grape_tag" placeholder="" id="add_grape_tag" type="text" class="validate" autocomplete="off" maxlength="50" v-model="addGrapeTag" v-on:keyup.enter="addTag">
        <div v-on:click="addTag" class="add-tag-trigger"><i class="far fa-plus"></i></div>
      </div>
      <div id="tags-list-wrap" class="show-tags">
        <h5 data-open="Hide Tags" data-closed="Show Tags" class="toggle-tags-link">Hide Tags</h5>
        <ul id="tags-list">
          <li v-for="tag in grapeTags">
            <a href="#" class="tag-link">{{ tag }}</a>
          </li>
        </ul>
      </div> -->
      <div id="highlights-wrap">
        <div class="input-field add-note-form" v-if="isLoggedIn">
          <label for="add_grape_note">What do you think of this grape?</label>
          <input name="add_grape_note" placeholder="Your text here" id="add_grape_note" type="text" class="validate" autocomplete="off" maxlength="50" v-model="newGrapeNote" v-on:keyup.enter="addGrapeNote">
          <div v-on:click="addGrapeNote" class="add-note-trigger"><i class="far fa-plus"></i></div>
        </div>
        <h5 class="aux-heading">{{grapeNotesCount}} notes</h5>
        <ul class="grape-notes-list">
          <li v-for="note in grapeNotes" :id="'note-' + note.id">
            <div class="user">@{{note.username}} <i class="fal fa-times" v-on:click="grapeNoteDelete(note.id)"></i></div>
            <div class="note-text">{{ note.text }}</div>
          </li>
        </ul>
      </div>
		</div>
    <div id="user-messages">
      <div class="messages-heading-wrap">
        <h5 class="aux-heading">Message</h5>
        <div class="button-back" v-on:click.stop.prevent="backToUserSearch()">
          <i class="fal fa-search"></i><span>Find</span>
        </div>
      </div>
      <MessagesList/>
    </div>
	</div>
</template>

<script>
  /* global $, mixpanel */
  import firebase from 'firebase'
  import db from './firebaseInit'
  import MessagesList from './MessagesList.vue'

  export default {
    name: 'RightSidebar',
    data () {
      return {
        isLoggedIn: false,
        selectedGrapeID: null,
        addGrapeTag: null,
        topTag: null,
        userSearchQuery: null,
        currentUserID: null,
        currentUserUsername: null,
        userSearchResults: [],
        grapeTags: [],
        grapes: [],
        grapevines: [],
        userTriggerReady: true,
        isTagsView: false,
        isUserView: false,
        isMessagesView: false,
        forceRHShow: false,
        highlightsCount: 0,
        grapeNotes: [],
        grapeNotesCount: 0,
        newGrapeNote: null,
        grapesDatabase: this.$globals.grapesDatabase,
        grapevinesDatabase: this.$globals.grapevinesDatabase,
        grapeRatingsDatabase: this.$globals.grapeRatingsDatabase,
        viewGrapeLink: 'view-grape',
        grapevineViewLink: 'grapevine',
        isPress: this.$globals.isPress
      }
    },
    props: {
      h: {
        type: Boolean
      }
    },
    created () {
      let vm = this
       if (this.isPress) {
        // this.viewGrapeLink = 'print-view-grape'
        // this.grapevineViewLink = 'print-grapevine'
      }
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.isLoggedIn = true
        }
      })
      this.$eventHub.$on('grape-tags-trigger', function (id, topTag) {
        vm.selectedGrapeID = id
        // vm.topTag = topTag
        // vm.grapeTags = []
        // vm.getTags()
        vm.grapeNotes = []
        vm.forceRHShow = true
        vm.isTagsView = true
        vm.getNotes()
      })
      this.$eventHub.$on('grape-user-trigger', function (id, username) {
        console.log('grape user trigger')
        if (vm.userTriggerReady) {
          vm.userTriggerReady = false
          vm.forceRHShow = true
          vm.viewUserProfile(id, username)
        }
      })
      this.$eventHub.$on('navigate-home', function () {
        vm.isUserView = false
        vm.isTagsView = false
        vm.isMessagesView = false
        vm.forceRHShow = false
        vm.userSearchQuery = ''
        vm.userSearchResults = []
        vm.grapes = []
        vm.grapevines = []
        vm.grapeTags = []
      })

      this.$eventHub.$on('mobile-message-show-trigger', function () {
        vm.isUserView = false
        vm.isTagsView = false
        vm.isMessagesView = true
        vm.forceRHShow = true
        $('body').addClass('overlay-panel-visible')
        $('body,html').css('height', '100%').css('overflow', 'hidden')
        console.log('mobile-message-show-trigger')
      })

      this.$eventHub.$on('mobile-message-hide-trigger', function () {
        vm.forceRHShow = false
        $('body').removeClass('overlay-panel-visible')
        $('body,html').css('height', '').css('overflow', '')
        console.log('mobile-message-hide-trigger')
      })

      this.$eventHub.$on('message-group', function (group) {
        vm.isUserView = false
        vm.isTagsView = false
        vm.isMessagesView = true
        vm.forceRHShow = true
      })

      // vm.indexUsers()
    },
    beforeDestroy () {
      this.$eventHub.$off('grape-tags-trigger')
      this.$eventHub.$off('grape-user-trigger')
      this.$eventHub.$off('navigate-home')
      this.$eventHub.$off('mobile-message-show-trigger')
      this.$eventHub.$off('mobile-message-hide-trigger')
      this.$eventHub.$off('message-group')
    },
    methods: {
      addGrapeNote: function () {
        let vm = this
        let userID = vm.currentUserID
        let noteData = {
          'grapeID': vm.selectedGrapeID,
          'userID': userID,
          'username': vm.$globals.userUsername,
          'text': vm.newGrapeNote,
          'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp()
        }
        mixpanel.track(
          'Create grape note',
          {
            'grapeID': vm.selectedGrapeID
          }
        )
        db.collection('grapeNotes').add(noteData).then(function (docRef) {
          console.log('Document written with ID: ', docRef.id)
          vm.$noty.success('Note added to Grape')
          vm.newGrapeNote = ''
          vm.grapeNotesCount++
          noteData.id = docRef.id
          vm.grapeNotes.push(noteData)
        })
      },
      getNotes: function () {
        let vm = this
        vm.isUserView = false
        vm.isTagsView = true
        vm.isMessagesView = false
        console.log(vm.selectedGrapeID)
        var notesRef = db.collection('grapeNotes').where('grapeID', '==', vm.selectedGrapeID)
        notesRef.get().then((querySnapshot) => {
          vm.grapeNotesCount = querySnapshot.docs.length
          querySnapshot.forEach((doc) => {
            var noteData = doc.data()
            noteData.id = doc.id
            if (vm.currentUserID == noteData.userID) {
              noteData.isOwner = true
            }
            vm.grapeNotes.push(noteData)
          })
        })
      },
      grapeNoteDelete: function (id) {
        let vm = this
        var retVal = confirm('Are you sure you want to delete this note?')
        if (retVal === true) {
          mixpanel.track(
            'Note deleted',
            {
              'noteID': id,
              'grapeID': vm.selectedGrapeID
            }
          )
          vm.grapeNotesCount--
          $('#note-' + id).slideUp(400)
          var noteRef = db.collection('grapeNotes').doc(id)
          noteRef.delete().then(function () {
            console.log('Document successfully deleted!')
            vm.grapeNotes = vm.grapeNotes.filter(note => note.id != id);
          }).catch(function (error) {
            console.error('Error removing document: ', error)
          })
          return true
        } else {
          return false
        }
      },
      getTags: function () {
        let vm = this
        vm.isUserView = false
        vm.isTagsView = true
        vm.isMessagesView = false
        console.log(vm.selectedGrapeID)
        firebase.database().ref('grape_tags/' + vm.selectedGrapeID).on('value', function (snapshot) {
          if (snapshot.val() !== null) {
            vm.grapeTags = Object.keys(snapshot.val())
          }
        })
      },
      addTag: function () {
        let vm = this
        let tag = this.addGrapeTag
        firebase.database().ref('tags').child(tag).once('value', function (snapshot) {
          var exists = (snapshot.val() !== null)
          vm.tagExistsCallback(tag, exists, snapshot.val())
        })
        firebase.database().ref('grape_tags/' + vm.selectedGrapeID).once('value', function (snapshot) {
          var grapeTagData = snapshot.val()
          if (grapeTagData === null) {
            grapeTagData = []
            grapeTagData[tag] = 0
            firebase.database().ref('grape_tags/' + vm.selectedGrapeID).set(grapeTagData)
          } else {
            grapeTagData[tag] = 0
            firebase.database().ref('grape_tags/' + vm.selectedGrapeID).update(grapeTagData)
          }
        })
        mixpanel.track(
          'Added tag',
          {
            'tag': tag,
            'grapeID': vm.selectedGrapeID
          }
        )
      },
      tagExistsCallback (tag, exists, val) {
        let vm = this
        if (exists) {
          let data = val.grapes
          if ($.inArray(vm.selectedGrapeID, data) === -1) {
            data.push(vm.selectedGrapeID)
            console.log('pushing: ' + vm.selectedGrapeID)
            firebase.database().ref('tags/' + tag).set({
              grapes: data
            })
          }
        } else {
          firebase.database().ref('tags/' + tag).set({
            grapes: [vm.selectedGrapeID]
          })
        }
      },
      indexUsers: function () {
        var userRef = firebase.database().ref('users')
        userRef.once('value', function (snapshot) {
          var data = snapshot.val()
          console.log(data)
        })
      },
      searchUsers: function () {
        let vm = this
        let queryText = this.userSearchQuery
        vm.userSearchResults = []
        var userRef = firebase.database().ref('users')
        userRef.orderByChild('username').startAt(queryText).endAt(queryText + '\uf8ff').once('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            var item = childSnapshot.val()
            item.key = childSnapshot.key
            vm.userSearchResults.push(item)
          })
        })
      },
      backToUserSearch: function () {
        let vm = this
        vm.isUserView = false
        vm.isTagsView = false
        vm.isMessagesView = false
        this.grapes = []
        this.grapevines = []
        mixpanel.track(
          'Back to user search'
        )
      },
      viewUserProfile: function (userID, username) {
        let vm = this
        vm.userTriggerReady = false
        vm.isUserView = true
        vm.isTagsView = false
        vm.isMessagesView = false
        mixpanel.track(
          'View user profile',
          {
            'userID': userID,
            'username': username
          }
        )
        vm.currentUserID = userID
        vm.currentUserUsername = username
        vm.getUserGrapes(userID)
        vm.getUserGrapevines(userID)
        $('#right-col').animate({ scrollTop: 0 }, 'slow')
        setTimeout(function () {
          vm.userTriggerReady = true
        }, 3000)
      },
      getUserGrapes: function (userID) {
        var vm = this
        vm.grapes = []
        console.log('getting user grapes')
        var grapesRef = db.collection(vm.grapesDatabase).where('grapeUserID', '==', userID)
        grapesRef.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var grapeData = doc.data()
            grapeData.docID = doc.id
            vm.grapes.push(grapeData)
          })
        })
      },
      getUserGrapevines: function (userID) {
        var vm = this
        vm.grapevines = []
        console.log('getting user grapevines')
        db.collection(vm.grapevinesDatabase).where('userID', '==', userID).where('privacy', '==', 'public').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log('fetch: ' + doc.id, ' => ', doc.data())
            let data = doc.data()
            var grapevineData = {
              name: data.name,
              id: doc.id,
              isReadOnly: false,
              grapes: data.grapes,
              grapeImage: null,
              count: data.grapeCount ? data.grapeCount : '',
              created: data.createdTimestamp ? data.createdTimestamp : ''
            }
            if (data.grapes) {
              grapevineData.count = data.grapes.length
            }
            if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true)) {
              vm.getGrapevineImage(grapevineData)
            }
          })
        })
      },
      getGrapevineImage: function (grapevine) {
        let vm = this
        if (grapevine.grapes && grapevine.grapes.length > 0 && !grapevine.image) {
          db.collection(vm.grapesDatabase).where('id', '==', grapevine.grapes[0]).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              grapevine.grapeImage = grapeData.sourceImage
              if (vm.isPress) {
                if (!grapeData.sourceImage) {
                  grapevine.grapeImage = 'static/img/' + grapeData.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
                }
              }
              vm.grapevines.push(grapevine)
              vm.grapevinesSort()
            })
          })
        } else {
          vm.grapevines.push(grapevine)
          vm.grapevinesSort()
        }
      },
      grapevinesSort: function () {
        let vm = this
        let $sort = $('#grapevines-sort').val()
        if ($sort === 'az') {
          vm.grapevines.sort(function (a, b) {
            var textA = a.name.toUpperCase()
            var textB = b.name.toUpperCase()
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
          })
        } else if ($sort === 'oldest') {
          vm.grapevines.sort(function (a, b) {
            var dateA = a.created ? parseFloat(a.created) : 0
            var dateB = b.created ? parseFloat(b.created) : 0
            return dateA - dateB
          })
        } else {
          vm.grapevines.sort(function (a, b) {
            var reverseTextA = a.created ? parseFloat(a.created) : 0
            var reverseTextB = b.created ? parseFloat(b.created) : 0
            return reverseTextB - reverseTextA
          })
        }
      },
      checkGrapevinePresent: function (inArr, grapevineID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === grapevineID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      checkGrapePresent: function (inArr, grapeID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === grapeID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      changeProfileTab: function (newTab) {
        $('#user-quick-profile').find('.tabs-nav > li').removeClass('current')
        $('#user-quick-profile').find('.tabs-nav > li[data-tab="' + newTab + '"]').addClass('current')
        if (newTab === 'grapes') {
          $('#users-grapes-list').addClass('visible').removeClass('hidden')
          $('#users-grapevines-list').addClass('hidden').removeClass('visible')
        } else if (newTab === 'grapevines') {
          $('#users-grapes-list').addClass('hidden').removeClass('visible')
          $('#users-grapevines-list').addClass('visible').removeClass('hidden')
        }
      },
      viewGrapevine: function () {
        this.$eventHub.$emit('external-trigger-grapevine')
      },
      goToMessages: function () {
        let vm = this
        vm.isUserView = false
        vm.isTagsView = false
        vm.isMessagesView = true
      },
      messageUser: function () {
        this.$eventHub.$emit('message-user', this.currentUserID, this.currentUserUsername)
        this.goToMessages()
      }
    },
    mounted: function () {
      $(document).on('click', '.toggle-tags-link', function () {
        if ($(this).parent().hasClass('show-tags')) {
          $(this).parent().removeClass('show-tags')
          $(this).text($(this).data('closed'))
        } else {
          $(this).parent().addClass('show-tags')
          $(this).text($(this).data('open'))
        }
      })
    },
    components: {
      MessagesList
    }
  };
</script>

<style scoped>
	.aux-col {
    box-sizing: border-box;
    text-align: left;
    overflow: hidden;
  }
  .aux-col > div {
  	padding: 30px 20px;
  	transform: translateX(0);
  	-moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
		-webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
		transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  }
  .aux-col h5.aux-heading {
    /*border-bottom: 1px solid #36a731;*/
    margin: 0 0 10px;
    padding-bottom: 8px;
    display: inline-block;
    font-size: 1em;
    font-weight: 100;
    max-width: 60%;
    color: #097b1e;
  }
  .users-heading-wrap > div {
    float: right;
    margin-left: 20px;
    padding: 0;
    cursor: pointer;
  }
  .users-heading-wrap > div:hover {
    color: #36a731;
  }
  .users-heading-wrap > div span {
    margin-left: 8px;
    font-size: 1em;
    font-weight: 100;
    opacity: 0.7;
    vertical-align: 2px;
  }
  .aux-col fieldset label {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    margin: 0 0 6px;
    display: block;
  }
  .aux-col fieldset input {
    width: 100%;
  }
  #right-col[hidesidebars="true"] {
    display: none!important;
  }
  #user-quick-profile {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    width: 100%;
  }
  #right-col.viewingUser #user-lookup {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  #right-col.viewingUser #user-quick-profile {
    transform: translateX(0);
  }

  #grapevines-list-wrap {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    width: 100%;
  }
  #right-col.viewingTags #user-lookup {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  #right-col.viewingTags #grapevines-list-wrap {
    transform: translateX(0);
  }

  #grape-aux-nav {
    list-style: none;
    margin: 0 0 30px;
    padding: 0;
    display: none;
  }
  #grape-aux-nav li {
    padding: 10px 15px;
    text-transform: uppercase;
    color: #ccc;
    -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  }
  #grape-aux-nav li:hover {
    cursor: pointer;
    color: #999;  
  }
  #grape-aux-nav li.active {
    background-color: #ccc;
    color: #222;
  }
  .add-tag-form, .add-note-form {
    position: relative;
    margin-bottom: 30px;
  }
  .add-tag-form label, .add-note-form label {
    font-size: .95em;
    font-weight: 100;
    margin: 0 0 6px;
    display: block;
    letter-spacing: .05em;
  }
  #add_grape_tag, #add_grape_note {
    width: 100%;
    line-height: 40px;
    padding: 0 30px 0 10px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }
  .add-tag-trigger, .add-note-trigger {
    position: absolute;
    right: 10px;
    bottom: 50%;
    transform: translateY(22px);
    cursor: pointer;
  }
  #top-tag-wrap {
    margin-bottom: 30px;
  }
  #top-tag-wrap h5 {
    margin: 0 0 8px;
    font-size: .95em;
    font-weight: 100;
    letter-spacing: .05em;
  }
  #top-tag-wrap span {
    color: #36a731;
    font-weight: 700;
    font-size: 18px;
  }
  #tags-list-wrap {
    margin-bottom: 20px;
  }
  #tags-list-wrap h5 {
    text-transform: uppercase;
    margin: 0 0 8px;
    padding-bottom: 0;
    display: inline-block;
    cursor: pointer;
    font-size: .95em;
    font-weight: 100;
    letter-spacing: .05em;
  }
  #tags-list {
    display: none;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  #tags-list-wrap.show-tags #tags-list {
    display: block;
  }
  #tags-list li {
    padding: 10px 0;
  }
  #tags-list li a {
    color: #36a731;
    font-weight: 400;
    font-size: 16px;
    text-decoration: none;
    -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  }
  .grape-notes-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .grape-notes-list li {
    margin-bottom: 15px;
  }
  .grape-notes-list li .user {
    font-weight: bold;
    margin-bottom: 4px;
  }
  .grape-notes-list li i {
    opacity: 0;
    float: right;
    cursor: pointer;
  }
  .grape-notes-list li:hover i {
    opacity: 1;
  }
  .user-search {
    position: relative;
    margin-bottom: 30px;
  }
  #search-users {
    width: 100%;
    line-height: 34px;
    padding: 10px 10px 10px 40px;
    box-sizing: border-box;
    background: transparent;
    border: 1px solid #ccc;
    border-left: 0;
    border-right: 0;
  }
  .search-trigger {
    position: absolute;
    left: 10px;
    top: 50%;
    margin-top: -9px;
    cursor: pointer;
  }
  #users-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  #users-list li {
    padding: 10px 0;
  }
  #users-list li a {
    color: #36a731;
    text-decoration: none;
    -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  }
  #users-list li a:hover {
    color: #222;
  }
  #user-quick-profile .tabs-nav {
    list-style: none;
    margin: 0 0 20px;
    padding: 0;
    clear: both;
    height: auto;
    overflow: hidden;
  }
  #user-quick-profile .tabs-nav li {
    width: 50%;
    float: left;
    text-align: center;
    cursor: pointer;
  }
  #user-quick-profile .tabs-nav li.current {
    font-weight: bold;
    cursor: default;
  }
  #user-quick-profile .tabs-nav li a {
    padding: 10px;
  }
  #users-grapes-list {
    padding-left: 0;
    list-style: none;
    margin-top: 0;
    margin-bottom: 30px;
    display: none;
  }
  #users-grapes-list.visible {
    display: block;
  }
  .message-user-button {
    width: 100%;
    margin-bottom: 20px;
  }
  .messages-heading-wrap > div {
    float: right;
    margin-left: 20px;
    padding: 0;
    cursor: pointer;
  }
  .messages-heading-wrap > div span {
    margin-left: 8px;
    opacity: 0.7;
    vertical-align: 2px;
  }
  .button-messages {
    position: relative;
  }
  #unread-message-count {
    background: #36a731;
    position: absolute;
    top: 2px;
    left: 0;
    font-size: 0;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    z-index: 3;
    opacity: 1;
    display: none;
  }
  #unread-message-count.hasUnread {
    display: block;
  }
  #user-messages {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    width: 100%;
  }
  #right-col.viewingMessages #user-lookup {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  #right-col.viewingMessages #user-messages {
    transform: translateX(0);
  }
  @media only screen and (min-width: 1200px) {
    #right-col {
      height: 100%;
      height: calc(100% - 53px);
      position: fixed;
      right: 0;
      left: auto!important;
      top: 53px;
      overflow-y: scroll;
      box-sizing: border-box;
      padding-bottom: 50px;
    }
  }
  @media only screen and (min-width: 1024px) and (max-width: 1199px) {
    #right-col {
      height: 100%;
      height: calc(100% - 130px);
      position: fixed;
      right: auto;
      left: 0;
      width: 25%;
      z-index: 3;
      top: 130px;
      overflow-y: scroll;
      padding-bottom: 50px;
      display: none;
    }
    .tablet-view-rh #right-col {
      display: block;
    }
    #right-col > div {
      padding-top: 0;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    #right-col {
      position: fixed;
      left: -266px;
      top: 133px;
      width: 256px;
      z-index: 98;
      box-sizing: border-box;
      background: #f9f9f9;
      border-right: 10px solid #fff;
      overflow: hidden;
    }
    .tablet-view-rh #right-col {
      z-index: 99;
    }
    /*.left-col-overlay-open #left-col {
      box-shadow: 5px 5px 36px -12px rgba(0,0,0,0.5);
    }*/
    #right-col {
      overflow: hidden;
    }
    #right-col > div {
      height: calc(100vh - 133px);
      box-sizing: border-box;
      top: 0;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      padding-top: 4px;
    }
  }
  @media only screen and (max-width: 767px) {
    #right-col {
      display: none;
      position: fixed;
      top: 0;
      z-index: 3;
      width: 100%;
      height: 100vh;
      background: #fff;
    }
    #right-col.forceShow {
      display: block;
      overflow-y: scroll;
    }
    #right-col #user-messages, #right-col #user-lookup {
      padding-top: 70px;
    }
    #right-col .messages-list {
      font-size: 16px;
    }
    .viewingTags #grapevines-list-wrap {
      padding-top: 70px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/RightSidebar.vue